// Outcomes of the Goods Delivery Note "Add Stock" scan lookup. The status strings are the API
// contract (GoodsDeliveryNoteFindStockStatuses in TMSWeb.Common) - keep the two in step.
export const GoodsDeliveryNoteFindStockStatuses = {
  ok: 'Ok',
  notFound: 'NotFound',
  alreadyOnNote: 'AlreadyOnNote',
  allocated: 'Allocated',
  inAnotherWarehouse: 'InAnotherWarehouse',
};
